export const AARegularTextContrast = 4.5
export const AANonTextContrast = 3
